import { RouteObject } from 'react-router'
import React, { lazy } from 'react'
import ProtectRouter from '../components/protect.router'

const Documents = lazy(() => import('../containers/documents/documents'))

const DocumentsRouter: RouteObject[] = [
    {
        path: '/app/documents',
        element: <ProtectRouter privateRouter={true} scopes={[
            'nfe:ra',
            'nfep:ra',
            'nfed:r',
            'cte:ra',
            'mdfe:ra',
        ]}>
            <Documents/>
        </ProtectRouter>
    }
]

export default DocumentsRouter
